import { render, staticRenderFns } from "./reformForm.vue?vue&type=template&id=122a037e&scoped=true&"
import script from "./reformForm.vue?vue&type=script&lang=js&"
export * from "./reformForm.vue?vue&type=script&lang=js&"
import style0 from "./reformForm.vue?vue&type=style&index=0&id=122a037e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a037e",
  null
  
)

export default component.exports